import { api } from "./client";

export type FollowupTemplate = {
  id: string;
  name: string;
  body: string;
};

export function listTemplates(): Promise<{ templates: FollowupTemplate[] }> {
  return api(`/follow-up-templates`);
}

export function createTemplate(input: {
  name: string;
  body: string;
}): Promise<{ template: FollowupTemplate }> {
  return api(`/follow-up-templates`, { method: "POST", body: input });
}

export function updateTemplate(
  id: string,
  patch: Partial<{ name: string; body: string }>,
): Promise<{ template: FollowupTemplate }> {
  return api(`/follow-up-templates/${id}`, { method: "PATCH", body: patch });
}

export function deleteTemplate(id: string): Promise<{ deleted: number }> {
  return api(`/follow-up-templates/${id}`, { method: "DELETE" });
}
